import classNames from "classnames";
const RightOrientation = ({
  className,
  isActive,
}: {
  className?: string;
  isActive: boolean;
}) => (
  <svg
    width={110}
    height={55}
    viewBox="0 0 110 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classNames(className, {
      "gg-fill-dark-blue": !isActive,
      "gg-fill-[#e5e5f1]": isActive,
    })}
  >
    <g fillRule="evenodd" clipRule="evenodd">
      <path d="M109.5 13.163V0h-4v11.163H92.726a2 2 0 0 0-1.17.378L36.33 51.378l2.34 3.244 54.702-39.459H107.5a2 2 0 0 0 2-2M.5 13V0h4v11h13v4h-15a2 2 0 0 1-2-2" />
      <path d="M17.5 20a1 1 0 0 0-1 1c0 5.734 1.356 10.444 3.87 14.486 2.132 3.43 5.071 6.339 8.638 8.979l-6.534 1.267a1 1 0 0 0 .381 1.963l8.835-1.713a1 1 0 0 0 .792-1.172l-1.713-8.836a1 1 0 0 0-1.964.38l1.239 6.388c-3.355-2.503-6.042-5.201-7.976-8.312C19.77 30.733 18.5 26.396 18.5 21a1 1 0 0 0-1-1" />
    </g>
  </svg>
);
export default RightOrientation;
